import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './SkipToContentMenu.less';

class SkipToContentMenu extends Component {
    static propTypes = {
        menuTitle: PropTypes.string.isRequired,
        ariaLabel: PropTypes.string.isRequired,
        menuItems: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        }))
    }

    state = {
        isVisible: false
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleShortcut);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleShortcut);
    }

    skipLinkRef = React.createRef();

    handleShortcut = (e) => {
        if (e.ctrlKey && e.keyCode === 81 && this.skipLinkRef.current) {
            this.skipLinkRef.current.focus();
        }
    };

    handleOnFocus = () => {
        this.setState({
            isVisible: true
        });
    };

    handleOnBlur = () => {
        this.setState({
            isVisible: false
        });
    };

    render() {
        const menuClassNames = classnames(
            'SkipToContentMenu',
            'text-left',
            {
                'sr-only': !this.state.isVisible
            }
        );
        const {menuItems, ariaLabel, menuTitle} = this.props;
        return (
            <div className={menuClassNames}>
                <div className="SkipToContentMenu__menuTitle">{menuTitle}</div>
                <ul className="SkipToContentMenu__menuList list-unstyled" aria-label={ariaLabel}>
                    {menuItems.map((menuItem, idx) => (
                        <li className="SkipToContentMenu__menuListItem" key={menuItem.id}>
                            <a
                                href={`#${menuItem.id}`}
                                onFocus={this.handleOnFocus}
                                onBlur={this.handleOnBlur}
                                {...(!idx ? {ref: this.skipLinkRef} : {})}
                            >
                                {menuItem.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default SkipToContentMenu;